<template lang="pug">
  .component-plan-smart-edit
    smart-edit(:options="options", :value="item", @input="updateFields")
    button.button.expanded(v-on:click="edit") Save and Submit

</template>
<script type="text/babel">
import SmartEdit from 'components/structure/SmartEdit'
import {mapState} from 'vuex'
import KeplerBackofficeSdk from "../../../lib/kepler/backoffice";
import MaggieHelper from "../../../maggieHelper";

export default {
  name: 'PlanSmartEdit',
  components: {SmartEdit},
  created() {
    if (this.item.toc) {
      this.$set(this.item, 'toc_id', this.item.toc.id)
    } else {
      this.$set(this.item, 'toc_id', null)
    }

  },
  data() {

    return {
      options: {
        types: {
          valid_from: 'datetimes',
          valid_to: 'datetimes',
          status: ['AVAILABLE', 'UNAVAILABLE', 'DISABLED'],
          featured: 'checkbox',
          renewable: 'checkbox',
          description: 'editor',
          picture: 'file',
          //toc_id: 'select',
        },
        file: {
          selectedVisibility: 'public',
          selectedPrefix: 'plans'
        },
        //select: this.tocs,
        translations: {
          billing_cycle: 'BILLING CYCLE (DAYS)',
          duration: 'Duration (DAYS)',
          valid_from: 'Active from',
          valid_to: 'Active to',
          cost: 'Cost (vat excluded)',
        },
        disabled: [
          'id',
          'created',
        ],
        list: [
          'id',
          'uid',
          'created',
          'toc',

        ],
        listMode: 'blacklist',
      }
    }
  },

  methods: {
    updateFields(item) {
      this.item = item
    },
    edit() {

      if (!this.item.renewable) {
        this.item.billing_cycle = this.item.duration
      }

      KeplerBackofficeSdk.plans.select(this.$route.params.id).edit(this.item, (data) => {
        MaggieHelper.notification('Plan saved', 'Plan saved successfully', 'success')
        MaggieHelper.closeRightPanel()
      })
    }
  },
  props: [
    'item',
    'tocs',
  ],
  computed: {
    ...mapState({
      configuration: state => state.configuration,
    })
  }
}
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// PlanEdit.vue?3ecb74e4